import { UtilisateurModel } from '../models/utilisateur/utilisateur.model';
import { DroitModelDTO } from './droitModelDTO';

export class UserModelDTO {
  public user: UtilisateurModel;
  public droits: DroitModelDTO[];
}
